import React from 'react'
import { Divider, Space } from 'antd'
import { Header, PricingToggle, SoftwareList, SeatList, Summary, Checkout } from './components'
import { PaymentMethodProvider, ShoppingProvider } from './hooks'
import { AccountPublic, BillingProduct, BillingSubscription } from '@pollination-solutions/pollination-sdk'

interface BillingFormProps {
  billingProducts: BillingProduct[],
  existingSubscriptions?: BillingSubscription[],
  account: AccountPublic
  onSuccess?: () => void
}

export const BillingForm: React.FC<BillingFormProps> = ({ 
  billingProducts, 
  account, 
  existingSubscriptions, 
  onSuccess 
}) => {

  return (
    <PaymentMethodProvider 
      billingProducts={billingProducts}
      existingSubscriptions={existingSubscriptions ?? []}
    >
      <ShoppingProvider>
        <Space direction='vertical'>
          <Header
            key={'software'}
            title={'Start by choosing concurrent use licenses'}
            description={
              <p>The number of concurrent use licenses determines the maximum number of simultaneous sessions for the Pollination Revit and Rhino plugins.</p>
            }
          />
          <PricingToggle />
          <SoftwareList />
        
          <Header
            key={'seat'}
            title={'Add seats for additional authorized users'}
            description={
              <p>The number of authorized users determines the total number of people on your team who will be eligible to use the concurrent licenses. Each authorized user can be assigned to a single Pollination account.</p>
            }
          />
          <SeatList />
          <Summary />

          <Divider />
          
          <Checkout 
            account={account} 
            onSuccess={onSuccess}
            existingSubscriptions={existingSubscriptions ?? []} />
        </Space>
      </ShoppingProvider>
    </PaymentMethodProvider>
  )
}
